import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

const RESOURCE_NAME = 'certificateRenderErrors.v1';

export const getCertificatePDFRenderingErrors = (verifyCode: string): Q.Promise<Array<string>> => {
  const api = API(`/api/${RESOURCE_NAME}/`, { type: 'rest' });
  const uri = new URI().addQueryParam('action', 'renderErrors').addQueryParam('verifyCode', verifyCode);

  return Q(
    api.post(uri.toString(), {
      data: {},
    })
  ).then((result) => {
    return result.map((obj: $TSFixMe) => obj.message);
  });
};
